module.exports = __webpack_public_path__ + "img/86-Colmar Eiche Spepia - Chêne Rustique.jpg";